<!--首页-->
<template>
  <div class="gray-back" style="height: 100%">
    <div class="box"  >

      <div style="background-color: #fff">
        <div class="news-title ">{{row.title}}</div>
        <div class="news-read-time">
        </div>
        <div class="news-content" v-html="row.content">
        </div></div>

      <div class="row4">
        <img  v-rblink="{name:'NewsList',query:{cate_id:row.id}}" v-for="(row,i) in catelist"  :src="row.pic_url" />
      </div>
  </div>
  </div>
</template>
<style scoped>

.box {
  background: #f8f8f8;
  padding-bottom: 50px;
  overflow: hidden;
  margin: 0.2rem auto;
}
.news-title{
  text-align: center;
  font-size:16px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(34,34,34,1);
}
.news-read-time{
  font-size:12px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(153,153,153,1);
  margin-top: 0.2rem;
}
.news-content{
  font-size:14px;
  text-align: center;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  margin-top: 20px;
  color:rgba(34,34,34,1);
  line-height:28px;
}
.news-content>>>img{max-width: 100% !important;}

  .row1{
    /*padding: 10px;*/
    margin: 0 10px;
  }
  .row4{
    /*display: flex;*/
    /*align-items: center;*/
    /*justify-content: space-between;*/
    margin: 10px 10px;
    /*flex-wrap: wrap;*/
  }
  .row4 img{
    width: 100%;
    float: left;
    width: calc(25% - 10px);
    margin: 0 10px 10px 0;
  }

</style>

<script>
import Vue from "vue";
import { Tab, Tabs, List, PullRefresh, Toast } from "vant";

import NewsItem2 from "@/components/news/NewsItem2.vue";
import NewsItem3 from "@/components/news/NewsItem3.vue";
import NewsItem1 from "@/components/news/NewsItem1.vue";
import NewsItem4 from "@/components/news/NewsItem4.vue";
import LoginDialog from '@/components/LoginDialog.vue';
Vue.use(Tab)
  .use(Tabs)
  .use(PullRefresh)
  .use(List)
  .use(Toast);

export default {
  name: "Wenhuaji",
  components: {
    NewsItem2,
    NewsItem3,
    NewsItem1,
    NewsItem4,
    LoginDialog
  },

  data: function() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      active: 0,
      activeTab: [
      ],
      catelist:[],
      list:[],
      row:{

      },
      params:{
        cate_id:64,
        pageNo:1,
        pageSize:10
      },
    };
  },
  filters: {
  },
  mounted() {
    document.title = "啦啦操文化季";
    this.params.pageNo = 1;
    this.loading = true;
    this.finished = false;
    let that = this;

    that.$api.get(
            "/api/cms/catelist",{
              parent_id:65
            },
            res => {
              that.catelist = res.data
            },
            res => {
              Toast(res.msg);
            }
    );

    this.fetch();
  },
  destroyed() {},
  methods: {
    fetch(){
      let that = this;
      that.$api.post('/api/cms/detail', {
        id: 31
      }, (res) => {
        that.row = res.data.data;
      }, (res) => {
        Toast.fail(res.msg);
      })
    },
  }
};
</script>



// WEBPACK FOOTER //
// Wenhuaji.vue?13e5805c